import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import NumericInput from "react-numeric-input";
import _ from "lodash";
import { Controller, useForm } from "react-hook-form";
import { AuthenticationContext, logUserIn } from "@cloudmlm/cloudmlm-auth";
import { useSelector } from "react-redux";
import { selectUserDetail } from "../../redux/slice/userSlice";

import {
  Box,
  Button,
  Card,
  Checkbox,
  Grid,
  Stack,
  Typography,
  Link,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  FormHelperText,
  FormControlLabel,
  MenuItem,
  Menu,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import dataConstant from "../../constants/dataConstants";
import urlConstant from "../../constants/urlConstants";
import {
  DecryptData,
  encryptData,
  httpGet,
  httpPost,
} from "../../services/commonService";
import SignupRefPopup from "../../shared-components/custom-popup/SignupRefPopup";
import SnackState from "../../shared-components/snackbar/snackState";
import CommonSnackBar from "../../shared-components/snackbar/commonSnackbar";
import { messageConstant } from "../../constants/messageConstant";
import {
  nameValidator,
  whiteSpaceValidator,
} from "../../shared-components/validator/fieldValidator";
import CustomPhoneField from "../../shared-components/form-controls/customPhoneField";
import CustomAutoCompleteDropdown from "../../shared-components/form-controls/customAutoCompleteDropdown";
import CustomTextField from "../../shared-components/form-controls/customTextField";
import { endApiLoader, startApiLoader } from "../../services/apiLoaderService";
import SignupCompletePopup from "../../shared-components/custom-popup/SignupCompletePopup";
import { getPhoneFieldValueFromRawNumber } from "../../shared-components/phoneHelper";
import i18n from "../../i18n";

let cardType = 0;
let userID = "";
let acctID = 0;
const locales = {
  en: { title: "English" },
  es: { title: "Spanish" },
};

const IBOSignup = () => {
  const authenticationState = useContext(AuthenticationContext);
  const { t } = useTranslation();
  const currentLang = i18n.language;
  const location = useLocation();
  const [snack, closeSnack, showSnackbar] = SnackState();
  const navigate = useNavigate();
  const [anchorElLanguage, setAnchorElLanguage] = useState(null);
  const [state, setState] = useState({
    isDisplay: false,
    signupModel: false,
    repModel: false,
    notFoundContent: false,
    RefAccountSiteName: "",
    selectedPackageName: "",
    packageName: "",
    hardCodeName: "",
    packageTotalAmount: 0,
    reoccurringPackageAmount: 0,
    iWalletAmount: 0,
    ccAmount: 0,
    isSubmitDisabled: true,
    countryId: 0,
    isAllDropDownCalled: false,
    IBOSignupUserInfo: {
      uniqueURL: "",
      RefAccountId: "",
      state: {},
      country: {},
      iWalletBalance: 0,
      countryData: [],
      stateData: [],
      isIWalletUsed: false,
      iWalletBalance: 0,
    },
    paymentData: [],
    totalDue: 0,
    isPaymentDetailsDisabled: false,
    isAllPaymentFromiWallet: false,
    disabled: false,
    phoneCountryCodeList: [],
    isAventiAccountCreated: false,
    aventiRedirectURL: "",
  });
  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const [recaptchaError, setRecaptchaError] = useState(false);
  const [isPhoneFiledForceUpdate, setIsPhoneFiledForceUpdate] = useState(true);
  const recaptchaSiteKey = `${process.env.REACT_APP_RECAPTCHA_SITE_KEY}`;
  const [isAventiUser, setIsAventiUser] = useState(false);
  const [isAventiProducts, setIsAventiProducts] = useState(false);
  const getLoggedUserDetails = useSelector(selectUserDetail);
  const AVENTI_TRAVEL_PRODUCTS = new Set(["aventibylder", "aventitravelbusinessenroll", "aventitravelenroll"]);
  const { isAventiUpgrade } = location.state || false

  const methods = useForm({
    mode: "all",
    defaultValues: {
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      replicaSiteName: "",
      address: "",
      city: "",
      state: null,
      country: null,
      zipcode: "",
      password: "",
      confirmPassword: "",
    },
  });
  const { handleSubmit, setValue, watch, trigger, setFocus, control } = methods;
  const password = watch("password");
  const confirmPassword = watch("confirmPassword");
  const handleRecaptchaChange = (value) => {
    setRecaptchaValue(value);
    setRecaptchaError(false);
  };

  const handlelanguageClick = (event) => {
    setAnchorElLanguage(event.currentTarget);
  };

  const handleLanguageClose = (lang) => {
    setAnchorElLanguage(null);
    if (lang) {
      i18n.changeLanguage(lang);
    }
  };

  /*useEffect(() => {
    const repURL = window.location.pathname.toLowerCase().split("/");
    const URLrepSiteName = repURL.indexOf("ibosignup");
    const packageName = repURL[URLrepSiteName + 1];

    const hasValidState = location.state?.upgrade === true;

    // Restriction logic for allowed upgrades per package type
    const allowedUpgradeMap = {
      "Affiliate": ["bylder", "aventitravelbusiness", "aventitravel"]
      , "Consulant": ["bylderupgrade"]
      , "Aventi Travel Business": ["atbbylderupgrade"]
      , "Aventi Travel": ["atbylderupgrade", "ataventitravelbusinessupgrade"]
    }

    // Get the latest package type from logged user details
    const latestPackageType = getLoggedUserDetails?.PurchasePackageDetails?.LatestPackageType;

    // Check if upgrade is allowed
    const isUpgradeAllowed = latestPackageType && allowedUpgradeMap[latestPackageType]?.includes(packageName);
    
    if (!hasValidState || !isUpgradeAllowed) {
      // Redirect to home if user modifies URL manually
      navigate('/home');
      return;
    }
  }, [location.state, navigate, getLoggedUserDetails]);*/

  useEffect(() => {
    const repURL = window.location.pathname.toLowerCase().split("/");
    const URLrepSiteName = repURL.indexOf("ibosignup");
  
    if (URLrepSiteName !== -1 && URLrepSiteName < repURL.length - 1) {
      let packageName = repURL[URLrepSiteName + 1];

      setIsAventiProducts(AVENTI_TRAVEL_PRODUCTS.has(packageName));

      if (packageName === "aventibylder") {
        setIsAventiUser(true);
        packageName = "BYLDer";
      } else if(packageName === 'aventitravelbusinessenroll') {
        setIsAventiUser(true);
        packageName = 'AventiTravelBusiness'
      } else if(packageName === 'aventitravelenroll') {
        setIsAventiUser(true);
        packageName = 'AventiTravel'
      } 

      setState((prevState) => ({
        ...prevState,
        selectedPackageName: packageName,
      }));

      if (packageName !== dataConstant.Undefined) {
        let model = {
          PackageType: packageName.toLowerCase(),
        };
        const packageAmountURL = urlConstant.IBOSignup.GetSignUpPackageTotalAmount;
        httpPost(packageAmountURL, model, true)
          .then((response) => {
            if (response.Status === dataConstant.APIResponseStatus.Success) {
              if (
                response.Values.ReoccurringPackage[0] !== dataConstant.Undefined
              ) {
                setState((prevState) => ({
                  ...prevState,
                  packageTotalAmount: response.Values.PackageTotalAmount,
                  packageName: response.Values.PackageName,
                  hardCodeName: response.Values.HardCodeName,
                  reoccurringPackageAmount:
                    response.Values.ReoccurringPackage[0]
                      .ReoccuringPackageAmount,
                  iWalletAmount: 0,
                  ccAmount: response.Values.PackageTotalAmount,
                  countryId: response.Values.CountryId,
                }));
              } else {
                setState((prevState) => ({
                  ...prevState,
                  packageTotalAmount: response.Values.PackageTotalAmount,
                  packageName: response.Values.PackageName,
                  hardCodeName: response.Values.HardCodeName,
                  reoccurringPackageAmount: 0,
                  iWalletAmount: 0,
                  ccAmount: response.Values.PackageTotalAmount,
                  countryId: response.Values.CountryId,
                }));
              }
            } else {
              navigate("/login");
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }

      const name = repURL[URLrepSiteName + 2];
      if (name !== "" && name !== undefined) {
        const e = {
          repID: name,
        };
        getREPId(e);
        setState((prevState) => ({
          ...prevState,
          RefAccountSiteName: name,
        }));
      } else {
        getREPPopup();
      }
    } else {
      navigate("/login");
    }
  }, []);

  useEffect(() => {
    if (state.packageName !== "") {
      getAllDropDownList();
    }
  }, [state.packageName]);

  useEffect(() => {
    if (confirmPassword) {
      trigger("confirmPassword");
    }
  }, [password, trigger]);

  useEffect(() => {
    if (state.isAllDropDownCalled) {
      if (
        location.state !== dataConstant.Undefined &&
        location.state?.upgrade === true
      ) {
        if (getLoggedUserDetails?.SignupSource === "aventi signup") {
          setIsAventiProducts(true);
        }
        getUserDetails();
      } else {
        const getCountryData = _.find(
          state.IBOSignupUserInfo.countryData,
          (item) => item.value === state.countryId
        );
        if (getCountryData !== undefined) {
          setValue("country", getCountryData);
          getStateDropDownList(state.countryId);
        } else {
          const getCountryData = _.find(
            state.IBOSignupUserInfo.countryData,
            (item) => item.value === 1
          );
          setValue("country", getCountryData);
          getStateDropDownList(getCountryData.value);
        }
      }
    }
  }, [state.isAllDropDownCalled]);

  useEffect(() => {
    if (state.IBOSignupUserInfo.RefAccountId !== "") {
      setFocus("firstName");
    }
  }, [state.IBOSignupUserInfo.RefAccountId]);

  const closeRepModelPopup = () => {
    getRandomREPId();
    setState((prevState) => ({
      ...prevState,
      repModel: false,
    }));
  };

  const getAllDropDownList = () => {
    const dropDownTypes = [dataConstant.AllDropDown.CoutryDropDown];
    const model = {
      DropDownTypes: _.join(dropDownTypes, ","),
    };
    httpPost(urlConstant.Common.GetAllDropDownList, model, true)
      .then((response) => {
        const countryList = response.Value.CoutryDropDownResult.Data;
        const getCountryData = _.find(
          countryList,
          (item) => item.value === state.countryId
        );
        setState((prevState) => ({
          ...prevState,
          isAllDropDownCalled: true,
          IBOSignupUserInfo: {
            ...prevState.IBOSignupUserInfo,
            countryData: countryList,
            country: getCountryData !== undefined ? getCountryData : {},
          },
          phoneCountryCodeList: countryList
            .filter((item) => !item.isDisabled)
            .map((item) => item.countryCode?.toLowerCase?.() || ""),
        }));
        if (getCountryData !== undefined) {
          setValue("country", getCountryData);
        }
        setIsPhoneFiledForceUpdate(!isPhoneFiledForceUpdate);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {});
  };

  const getRandomREPId = async () => {
    const dataModel = {};
    httpPost(urlConstant.IBOSignup.GetRandomReferenceId, dataModel, true)
      .then((response) => {
        if (response.Status !== dataConstant.APIResponseStatus.Failure) {
          setState((prevState) => ({
            ...prevState,
            repModel: false,
            RefAccountSiteName: response.Value.RefName,
            IBOSignupUserInfo: {
              ...prevState.IBOSignupUserInfo,
              RefAccountId: response.Value.AccountId,
            },
          }));
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getREPId = async (event) => {
    const dataModel = {
      ReferenceId: event.repID,
    };
    httpPost(urlConstant.IBOSignup.GetReferenceId, dataModel, true)
      .then((response) => {
        if (response.Status === dataConstant.APIResponseStatus.Failure) {
          getREPPopup();
        }
        if (response.Status !== dataConstant.APIResponseStatus.Failure) {
          setState((prevState) => ({
            ...prevState,
            repModel: false,
            RefAccountSiteName: response.Value.RefName,
            IBOSignupUserInfo: {
              ...prevState.IBOSignupUserInfo,
              RefAccountId: response.Value.AccountId,
            },
          }));
        } else {
          showSnackbar(response?.error, "error");
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getREPPopup = () => {
    if (
      state.RefAccountSiteName === dataConstant.Undefined ||
      state.RefAccountSiteName === ""
    ) {
      setState((prevState) => ({
        ...prevState,
        repModel: true,
      }));
    }
  };

  const deleteGenerateToken = (index) => {
    cardType = 0;
    let { paymentData } = state;
    let removeCardDetails = paymentData;
    removeCardDetails.splice(index, 1);
    // Reset cardType and reload AcceptJS if no cards remain
    if (removeCardDetails.length === 0) {
      cardType = 0;
      const acceptJsUrl = process.env.REACT_APP_ACCEPT_JS_URL;
      // Remove old AcceptJS script if present
      const oldScript = document.querySelector(`script[src="${acceptJsUrl}"]`);
      if (oldScript) {
        oldScript.remove();
      }
      // Add new AcceptJS script
      const script = document.createElement("script");
      script.src = acceptJsUrl;
      script.async = true;
      script.onload = () => {
        window.responseHandlerHosted = responseHandlerHosted;
      };
      document.body.appendChild(script);
    }

    const isIWalletUsed = state.IBOSignupUserInfo.isIWalletUsed;
    const iWalletAmount = state.iWalletAmount;
    const packageTotal = state.packageTotalAmount;
    const shouldDisableSubmit =
      (!isIWalletUsed && removeCardDetails.length === 0) ||
      (isIWalletUsed &&
        iWalletAmount < packageTotal &&
        removeCardDetails.length === 0);
    setState((prevState) => ({
      ...prevState,
      paymentData: removeCardDetails,
      isPaymentDetailsDisabled: removeCardDetails.length > 0,
      isSubmitDisabled: shouldDisableSubmit,
    }));
  };

  const getUserDetails = async () => {
    const getUserfoURL = urlConstant.IBOSignup.GetUserDetails;
    await httpGet(
      getUserfoURL,
      true,
      true,
      authenticationState.accessToken,
      authenticationState.impersonateEmail
    )
      .then(async (response) => {
        if (response.Value.Status === dataConstant.APIResponseStatus.Success) {
          cardType = 0;
          userID = response.Value.Data.UserID;
          const responseData = response.Value.Data.ApplicationUser;
          await getStateDropDownList(
            responseData.CountryID,
            responseData.StateID
          );
          acctID = responseData.AcctID;
          const getCountryData = _.find(
            state.IBOSignupUserInfo.countryData,
            (item) => item.value === responseData.CountryID
          );
          if (getCountryData !== undefined) {
            setValue("country", getCountryData);
          }
          setValue("firstName", responseData.FirstName);
          setValue("lastName", responseData.LastName);
          setValue("email", responseData.Email);
          setValue("city", responseData.City);
          setValue("zipcode", responseData.Zipcode);
          setValue("address", responseData.Address1);
          setValue("replicaSiteName", responseData.ReplicationSiteName);
          if (responseData.PrivatePhoneNumber !== null) {
            const phoneFieldValue = getPhoneFieldValueFromRawNumber(
              responseData.PrivatePhoneNumber
            );
            if (phoneFieldValue) {
              setValue("phoneNumber", phoneFieldValue);
            }
          }
          setIsPhoneFiledForceUpdate(!isPhoneFiledForceUpdate);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    const url = `${process.env.REACT_APP_ACCEPT_JS_URL}`;
    loadScript(url);
    window.responseHandlerHosted = responseHandlerHosted;
  }, []);

  // Load AcceptJS In Component
  const loadScript = (src) => {
    var tag = document.createElement("script");
    tag.src = src;
    document.body.appendChild(tag);
  };

  const responseHandlerHosted = (data) => {
    if (data && data.messages.resultCode === "Ok") {
      cardType = data.encryptedCardData.bin.charAt(0);
      const cardDetailsAlredyExists = _.find(
        state.paymentData,
        function searchCard(obj) {
          return obj.token === data.opaqueData.dataValue;
        }
      );
      if (cardDetailsAlredyExists === dataConstant.Undefined) {
        let PaymentAmount = 0;
        if (state.paymentData.length === 0) {
          PaymentAmount = state.packageTotalAmount;
        } else {
          const paymentArray = _.pluck(state.paymentData, "amount");
          const currentAmount = parseFloat(
            paymentArray.reduce((a, b) => a + b, 0)
          );
          PaymentAmount = state.packageTotalAmount - currentAmount;
        }
        if (PaymentAmount < 0) {
          PaymentAmount = 0.0;
        }
        const HostedCardDetails = {
          cardNumber: data.encryptedCardData.cardNumber,
          expDate: data.encryptedCardData.expDate,
          token: data.opaqueData.dataValue,
          amount: state.packageTotalAmount,
        };
        const paymentList = state.paymentData;
        paymentList.push(HostedCardDetails);
        setState((prevState) => ({
          ...prevState,
          paymentData: paymentList,
          isSubmitDisabled: false,
          isPaymentDetailsDisabled: true,
        }));
      }
    } else if (data && data.messages.resultCode === "Error") {
      var i = 0;
      let message = "";
      while (i < data.messages.message.length) {
        message = data.messages.message[i].text;
        i = i + 1;
      }
      if (message !== "") {
        showSnackbar(message, "error");
      }
    }
  };

  const getStateDropDownList = async (countryId, stateId = 0) => {
    if (countryId !== null) {
      await httpGet(
        `${urlConstant.Common.GetStateList}?CountryId=${countryId}`,
        true
      )
        .then((response) => {
          let stateValue = null;
          if (stateId !== 0) {
            stateValue = _.find(response.Value.Data, (i) => {
              return i.value === stateId;
            });
          }
          setState((prevState) => ({
            ...prevState,
            IBOSignupUserInfo: {
              ...prevState.IBOSignupUserInfo,
              stateData: response.Value.Data,
              state: stateValue === null ? {} : stateValue,
            },
          }));
          setValue("state", stateValue);
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {});
    }
  };

  const cardTypeLogo = () => {
    switch (cardType) {
      case "2":
      case "5":
        return (
          <img
            alt="Master Card"
            style={{ height: "30px" }}
            src={`${process.env.REACT_APP_BLOB_URL}/backoffice-assets/mastercard.png`}
          />
        );
      case "3":
        return (
          <img
            alt="American Express"
            style={{ height: "30px" }}
            src={`${process.env.REACT_APP_BLOB_URL}/backoffice-assets/american-express.png`}
          />
        );
      case "4":
        return (
          <img
            alt="Visa"
            style={{ height: "30px" }}
            src={`${process.env.REACT_APP_BLOB_URL}/backoffice-assets/visa.png`}
          />
        );
      case "6":
        return (
          <img
            alt="Discover"
            style={{ height: "30px" }}
            src={`${process.env.REACT_APP_BLOB_URL}/backoffice-assets/discover.png`}
          />
        );
      default:
        return null;
    }
  };

  const handleCountryChange = (value) => {
    if (value) {
      getStateDropDownList(value.value);
    }
  };

  const formConfig = {
    firstNameParamValueId: {
      name: "firstName",
      label: t("PublicInfo.First Name"),
      isDisabled: location.state?.upgrade,
      required: true,
      type: "text",
      maxLength: 100,
      validation: {
        validate: nameValidator("PublicInfo.First Name"),
      },
    },
    lastNameParamValueId: {
      name: "lastName",
      label: t("PublicInfo.Last Name"),
      isDisabled: location.state?.upgrade,
      required: true,
      type: "text",
      maxLength: 100,
      validation: {
        validate: nameValidator("PublicInfo.Last Name"),
      },
    },
    emailParamValueId: {
      name: "email",
      label: t("PublicInfo.Email Address"),
      isDisabled: location.state?.upgrade,
      type: "email",
      maxLength: 100,
      required: true,
    },
    replicaSiteNameParamValueId: {
      name: "replicaSiteName",
      label: t("SignupCommonField.Common.ReplicatedWebsiteName"),
      isDisabled: location.state?.upgrade,
      type: "text",
      maxLength: 100,
      required: true,
      className: "cm-sitename",
      validation: {
        validate: nameValidator(
          "SignupCommonField.Common.ReplicatedWebsiteName"
        ),
      },
    },
    addressParamValueId: {
      name: "address",
      label: t("SignupCommonField.Common.Address"),
      type: "text",
      maxLength: 200,
      required: true,
      validation: {
        validate: whiteSpaceValidator("SignupCommonField.Common.Address"),
      },
    },
    cityParamValueId: {
      name: "city",
      label: t("SignupCommonField.Common.City"),
      type: "text",
      maxLength: 100,
      required: true,
      validation: {
        validate: whiteSpaceValidator("SignupCommonField.Common.City"),
      },
    },
    stateParamValueId: {
      name: "state",
      label: t("SignupCommonField.Common.State"),
      dropDownList: state.IBOSignupUserInfo.stateData,
      required: true,
    },
    countryParamValueId: {
      name: "country",
      label: t("SignupCommonField.Common.Country"),
      dropDownList: state.IBOSignupUserInfo.countryData,
      required: true,
      isDisabled: location.state?.upgrade ? true : false,
      customOnChange: handleCountryChange,
    },
    zipcodeParamValueId: {
      name: "zipcode",
      label: t("SignupCommonField.Common.ZipCode"),
      type: "text",
      maxLength: 10,
      required: true,
      validation: {
        validate: whiteSpaceValidator("SignupCommonField.Common.ZipCode"),
      },
    },
    passwordParamValueId: {
      name: "password",
      label: t("SignupCommonField.Common.Password"),
      type: "password",
      maxLength: 100,
      required: true,
    },
    confirmPasswordParamValueId: {
      name: "confirmPassword",
      label: t("SignupCommonField.Common.ConfirmPassword"),
      type: "password",
      maxLength: 100,
      required: true,
      validation: {
        validate: (value) =>
          value === password ||
          t(
            "SignupCommonField.Common.Password and confirm password does not match"
          ),
      },
    },
  };

  const onSubmit = (event) => {
    if (!recaptchaValue) {
      setRecaptchaError(true);
      return;
    }
    if (acctID > 0) {
      setState((prevState) => ({
        ...prevState,
        isSubmitDisabled: true,
      }));

      const model = {
        UserID: userID,
        Email: event.email.toLowerCase(),
        RefAccountId: state.IBOSignupUserInfo.RefAccountId,
        PackageType: state.selectedPackageName,
        PaymentDetails: state.isAllPaymentFromiWallet
          ? []
          : [
              {
                amount: state.ccAmount,
                cardNumber: state.paymentData[0].cardNumber,
                expDate: state.paymentData[0].expDate,
                token: state.paymentData[0].token,
              },
            ],
        PhoneNumber: event.phoneNumber.fullNumber,
        Address: event.address,
        City: event.city,
        StateID: event.state ? event.state.value : null,
        Zipcode: event.zipcode,
        iWalletAmount: state.iWalletAmount,
        RecaptchaResponse: recaptchaValue,
      };
      const upgradeURL = urlConstant.IBOSignup.UpgradeProcess;
      httpPost(upgradeURL, model, true)
        .then((response) => {
          if (response.Status === dataConstant.APIResponseStatus.Success) {
            setState((prevState) => ({
              ...prevState,
              signupModel: true,
            }));
            localStorage.setItem("email", event.email.toLowerCase());
            localStorage.setItem("password", encryptData(event.password));
          } else {
            showSnackbar(response.error, "errorr");
            return response.error;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      setState((prevState) => ({
        ...prevState,
        isSubmitDisabled: true,
      }));
      const model = {
        FirstName: event.firstName,
        LastName: event.lastName,
        PhoneNumber: event.phoneNumber.fullNumber,
        Email: event.email.toLowerCase(),
        ReplicatedSite: event.replicaSiteName,
        Password: encryptData(event.password),
        Address: event.address,
        City: event.city,
        StateID: event.state ? event.state.value : null,
        CountryID: event.country
          ? event.country[0]
            ? event.country[0].value
            : event.country.value
          : null,
        Zipcode: event.zipcode,
        RefAcctID: state.IBOSignupUserInfo.RefAccountId,
        PackageType: state.selectedPackageName,
        PaymentDetails: [
          {
            amount: state.packageTotalAmount,
            cardNumber: state.paymentData[0].cardNumber,
            expDate: state.paymentData[0].expDate,
            token: state.paymentData[0].token,
          },
        ],
        RecaptchaResponse: recaptchaValue,
        SignupFrom: isAventiUser ? "Aventi Signup" : "",
      };
      const createURL = urlConstant.IBOSignup.CheckoutProcess;
      httpPost(createURL, model, true)
        .then((response) => {
          if (response.Status === dataConstant.APIResponseStatus.Success) {
            setState((prevState) => ({
              ...prevState,
              signupModel: true,
              isAventiAccountCreated: response?.Values?.IsAventiAccountCreated,
              aventiRedirectURL: response?.Values?.AventiRedirectURL,
            }));
            localStorage.setItem("email", event.email.toLowerCase());
            localStorage.setItem("password", encryptData(event.password));
          } else {
            showSnackbar(response.error, "error");
            if (
              response.error.toLowerCase().includes("email") ||
              response.error.toLowerCase().includes("replication") ||
              response.error.toLowerCase().includes("iwallet")
            ) {
              setState((prevState) => ({
                ...prevState,
                isSubmitDisabled: false,
              }));
            }
            return response.error;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };

  const handleDashboard = async (goToAventi) => {
    setState((prevState) => ({
      ...prevState,
      signupModel: false,
    }));
    if (acctID > 0) {
      if (location.state?.upgrade === true) {
        window.location.href = "/order";
      } else {
        window.location.href = "/home";
      }
    } else {
      const autoLoginCredentials = {
        username: localStorage.getItem("email"),
        password: DecryptData(localStorage.getItem("password")),
        tokenUrl: process.env.REACT_APP_ROPC_TOKEN_URL,
        grantType: "password",
        scope: `${process.env.REACT_APP_AZURE_AD_B2C_SCOPE} openid offline_access`,
        clientId: process.env.REACT_APP_AZURE_AD_B2C_CLIENTID,
        responseType: "token",
      };
      startApiLoader();
      logUserIn(autoLoginCredentials)
        .then((result) => {
          authenticationState.logUserIn(result);
          const authObject = JSON.parse(localStorage.getItem("auth"));
          if (authObject !== dataConstant.Undefined && authObject !== null) {
            localStorage.setItem("InitialToken", authObject.accessToken);
            if ((goToAventi === "bookNow" || goToAventi === "dashboardAventi") && state.isAventiAccountCreated) {
              navigate("/aventitravel");
              if (goToAventi == "bookNow") {
                handleOpenNewPage(state.aventiRedirectURL);
              }
            } else {
              navigate("/home");
            }
          }
          endApiLoader();
          console.log("Auto-login successful");
        })
        .catch((e) => {
          console.error("Auto-login failed:", e);
        });
    }
  };

  const handleOpenNewPage = (redirectURL) => {
    const newWindow = window.open();
    if (newWindow) {
      newWindow.document.write(redirectURL);
      newWindow.document.close();
    } else {
      alert("Please allow popups to open the redirect page.");
    }
  };

  const getiWalletSummaryDetails = () => {
    httpGet(
      urlConstant.iWallet.GetiWalletSummary,
      true,
      true,
      authenticationState.accessToken,
      authenticationState.impersonateEmail
    )
      .then((response) => {
        const responseData = response.Value.Data;
        setState((prevState) => ({
          ...prevState,
          IBOSignupUserInfo: {
            ...prevState.IBOSignupUserInfo,
            iWalletBalance: responseData.TotaliWalletbalance,
          },
          iWalletAmount:
            responseData.TotaliWalletbalance >= prevState.packageTotalAmount
              ? prevState.packageTotalAmount
              : responseData.TotaliWalletbalance,
          ccAmount:
            responseData.TotaliWalletbalance >= prevState.packageTotalAmount
              ? 0
              : prevState.packageTotalAmount - responseData.TotaliWalletbalance,
          isAllPaymentFromiWallet:
            responseData.TotaliWalletbalance >= prevState.packageTotalAmount
              ? true
              : false,
          isSubmitDisabled:
            responseData.TotaliWalletbalance >= prevState.packageTotalAmount
              ? false
              : prevState.paymentData.length === 0,
        }));
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleIWalletAmountChange = (e) => {
    const value = parseFloat(e);
    if (value < 0) {
        showSnackbar(t("SignupCommonField.IBOSignup.NegativeValueError"), "error");
      return;
    }
    const maxPackage = state.packageTotalAmount;
    const maxIWallet = state.IBOSignupUserInfo.iWalletBalance;

    if (value > maxPackage) {
      showSnackbar(t("SignupCommonField.IBOSignup.AmountExceedError"), "error");
      return;
    }
    if (value > maxIWallet) {
      showSnackbar(t("SignupCommonField.IBOSignup.IwalletExceedError"), "error");
      return;
    }
    setState((prevState) => ({
      ...prevState,
      iWalletAmount: e,
      ccAmount: prevState.packageTotalAmount - e,
      isAllPaymentFromiWallet:
        e === prevState.packageTotalAmount ? true : false,
      isPaymentDetailsDisabled: prevState.paymentData.length > 0,
      isSubmitDisabled:
        e < prevState.packageTotalAmount && prevState.paymentData.length === 0
          ? true
          : false,
    }));
  };

  const handleUseiWalletchange = (e) => {
    if (e === true) {
      getiWalletSummaryDetails();
      setState((prevState) => ({
        ...prevState,
        IBOSignupUserInfo: {
          ...prevState.IBOSignupUserInfo,
          isIWalletUsed: true,
        },
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        IBOSignupUserInfo: {
          ...prevState.IBOSignupUserInfo,
          isIWalletUsed: false,
        },
        iWalletAmount: 0,
        ccAmount: prevState.packageTotalAmount,
        isPaymentDetailsDisabled: prevState.paymentData.length > 0,
        isSubmitDisabled: prevState.paymentData.length === 0,
      }));
    }
  };

  return (
    <>
      <Box flexDirection={"column"} gap={2} display={"flex"}>
        <Box width={"100%"}>
          <Card
            sx={(theme) => ({
              p: {
                xs: "20px",
                sm: "25px 30px",
              },
              background: "rgba(var(--black-rgb), 0.2)",
              backdropFilter: "blur(50px)",
              border: "1px solid var(--headerbg)",
              borderRadius: "20px",
              borderTopLeftRadius: "0",
              borderTopRightRadius: "0",
              height: "100%",
            })}
          >
            <Stack gap={"20px"}>
              <Grid container spacing={2}>
                <Stack
                  gap={2}
                  direction={"row"}
                  flexWrap={"wrap"}
                  alignItems={"center"}
                  width={"100%"}
                >
                   { isAventiProducts || isAventiUpgrade ? (
                      <img
                        src={`${process.env.REACT_APP_BLOB_URL}/backoffice-assets/website-logos/AventiLogo-White.png`}
                        alt="Aventi Logo" style={{ width: "150px", height: "auto" }}
                      />
                    ) : (
                      <img
                        src={`${process.env.REACT_APP_BLOB_URL}/backoffice-assets/logo-header.svg`}
                        alt="logo"
                      />
                    )}
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={handlelanguageClick}
                  >
                    {currentLang.toUpperCase()}
                  </Button>
                  <Typography
                    color="secondary.light"
                    variant="h4"
                    fontWeight={600}
                  >
                    {isAventiProducts || isAventiUpgrade ? state.packageName : state.hardCodeName} {t("SignupCommonField.IBOSignup.Title")}
                  </Typography>
                  <Typography variant="h4" color="primary.main">
                    {t( isAventiProducts || isAventiUpgrade ? "SignupCommonField.Common.AffiliateName" : "SignupCommonField.Common.IBOName" )}
                    {state.RefAccountSiteName}
                  </Typography>
                </Stack>
              </Grid>
            </Stack>
          </Card>
        </Box>
        <Grid container spacing={3} sx={{ flexGrow: 1, marginBottom: "25px" }}>
          <Grid mx={"auto"} size={{ xs: 12, sm: 10 }}>
            <Card
              sx={(theme) => ({
                p: {
                  xs: "20px",
                  sm: "25px 30px",
                },
                background: theme.palette.background.cardGradient,
                border: "1px solid var(--headerbg)",
                borderRadius: "20px",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "20px",
              })}
            >
              <Stack gap={1}>
                <Typography variant="h4" fontWeight={800} color="primary">
                  {t("SignupCommonField.IBOSignup.WelcomeTitle")}
                </Typography>
                <Typography variant="body1" color="secondary.light">
                  {t( isAventiProducts || isAventiUpgrade ? "SignupCommonField.IBOSignup.AventiWelcomeNote" : "SignupCommonField.IBOSignup.WelcomeNote1" )}
                </Typography>
              </Stack>

              <Typography variant="h5" fontWeight={800} color="secondary.light">
                {t("SignupCommonField.Common.ContactInformation")}
              </Typography>
              <form noValidate onSubmit={handleSubmit(onSubmit)}>
                <Stack gap={2}>
                  <Grid container spacing={3}>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <CustomTextField
                        methods={methods}
                        properties={formConfig.firstNameParamValueId}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <CustomTextField
                        methods={methods}
                        properties={formConfig.lastNameParamValueId}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <CustomTextField
                        methods={methods}
                        properties={formConfig.emailParamValueId}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <CustomPhoneField
                        control={control}
                        isPhoneFiledForceUpdate={isPhoneFiledForceUpdate}
                        name="phoneNumber"
                        label={t("PublicInfo.Phone Number")}
                        required={true}
                        countryList={state.phoneCountryCodeList}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <Stack
                        className={`customfield-label ${isAventiProducts || isAventiUpgrade ? "input-extra-label" : ""}`}
                        sx={{
                          maxWidth: "700px",
                          width: "100%",
                          flexDirection: "row",
                          alignItems: "flex-start",
                        }}
                      >
                        <CustomTextField
                          methods={methods}
                          properties={formConfig.replicaSiteNameParamValueId}
                        />
                        <Card
                          className="customfield-label-inner"
                          sx={{
                            marginTop: "21px",
                            display: {
                              xs: "none !important",
                              sm: "flex !important",
                            },
                          }}
                        >
                          { isAventiProducts || isAventiUpgrade ? process.env.REACT_APP_AVENTITRAVEL_DOMAIN_NAME : process.env.REACT_APP_BYLD_DOMAIN_NAME}
                        </Card>
                      </Stack>
                      <Typography
                        variant="body2"
                        sx={{ fontSize: "10px" }}
                        color="secondary.main"
                      >
                        {t( isAventiProducts || isAventiUpgrade ? "SignupCommonField.Common.AventiTravelReplicaNoteMessage" : "SignupCommonField.Common.ReplicaNoteMessage" )}
                      </Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <CustomAutoCompleteDropdown
                        methods={methods}
                        properties={formConfig.countryParamValueId}
                      />
                    </Grid>
                    {!location.state?.upgrade && (
                      <>
                        <Grid size={{ xs: 12, sm: 6 }}>
                          <CustomTextField
                            methods={methods}
                            properties={formConfig.passwordParamValueId}
                          />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                          <CustomTextField
                            methods={methods}
                            properties={formConfig.confirmPasswordParamValueId}
                          />
                        </Grid>
                      </>
                    )}
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <CustomTextField
                        methods={methods}
                        properties={formConfig.addressParamValueId}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <CustomAutoCompleteDropdown
                        methods={methods}
                        properties={formConfig.stateParamValueId}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <CustomTextField
                        methods={methods}
                        properties={formConfig.cityParamValueId}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <CustomTextField
                        methods={methods}
                        properties={formConfig.zipcodeParamValueId}
                      />
                    </Grid>
                  </Grid>

                  <Typography
                    variant="h5"
                    fontWeight={800}
                    color="secondary.light"
                  >
                    {t("SignupCommonField.IBOSignup.PaymentDetails")}
                  </Typography>
                  {location.state?.upgrade && (
                    <Stack>
                      <Box>
                        <FormControlLabel
                          control={
                            <Checkbox
                              id="isIWalletUsed"
                              name="isIWalletUsed"
                              checked={state.IBOSignupUserInfo.isIWalletUsed}
                              onChange={(e) =>
                                handleUseiWalletchange(e.target.checked)
                              }
                            />
                          }
                          label={
                            i18n?.t
                              ? i18n.t(
                                  "SignupCommonField.IBOSignup.CheckboxiWalletText"
                                )
                              : "Use iWallet Balance"
                          }
                        />
                      </Box>
                      {state.IBOSignupUserInfo.isIWalletUsed && (
                        <Box textAlign="center">
                          <Card
                            sx={(theme) => ({
                              p: {
                                xs: "20px",
                                sm: "25px 30px",
                              },
                              background: theme.palette.common.black,
                              border: "1px solid var(--headerbg)",
                              borderRadius: "20px",
                            })}
                          >
                            <Typography variant="h6" color="secondary.light">
                              {t("IWallet.iWallet Balance")}
                            </Typography>

                            <Typography variant="h4"  color="primary" my={1} fontWeight={600}>
                              {`$${state.IBOSignupUserInfo.iWalletBalance.toFixed(
                                dataConstant.TwoDigitConstValue
                              )} ${t("Common.USD")}`}
                            </Typography>

                            <Typography variant="body2" color="secondary.text">
                              {t("SignupCommonField.IBOSignup.WithdrawAmount")}
                            </Typography>

                            <Box display="flex" justifyContent="center">
                              <NumericInput
                                id="number"
                                className="cm-textfield-slided"
                                name="number"
                                pattern="[0-9].[0-9][0-9]"
                                defaultValue={
                                  state.IBOSignupUserInfo.iWalletBalance
                                }
                                value={state.iWalletAmount}
                                type="number"
                                onChange={(event) =>
                                  handleIWalletAmountChange(event)
                                }
                                max={
                                  state.packageTotalAmount <
                                  state.IBOSignupUserInfo.iWalletBalance
                                    ? state.packageTotalAmount
                                    : state.IBOSignupUserInfo.iWalletBalance
                                }
                                min={0}
                                i18n={i18n}
                              />
                            </Box>
                          </Card>
                        </Box>
                      )}
                    </Stack>
                  ) }
                  {state.paymentData.length === 0 && (
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <Button
                      variant="contained"
                      disabled={state.isPaymentDetailsDisabled}
                      type="button"
                      className="AcceptUI"
                      data-billingaddressoptions='{"show":true, "required":true}'
                      data-apiloginid={
                        process.env.REACT_APP_AUTHNET_API_LOGIN_KEY
                      }
                      data-clientkey={
                        process.env.REACT_APP_AUTHNET_API_CLIENT_KEY
                      }
                      data-acceptuiformbtntxt={
                        messageConstant.Payment.SubmitFormTitle
                      }
                      data-acceptuiformheadertxt={
                        messageConstant.PaymentProfile
                          .AddPaymentProfileButtonTitle
                      }
                      data-paymentoptions='{"showCreditCard": true, "showBankAccount": false}'
                      data-responsehandler="responseHandlerHosted"
                    >
                      {t(
                        "SignupCommonField.IBOSignup.AddPaymentDetailsButtonText"
                      )}
                    </Button>
                  </Grid>
                  )}
                  <Grid size={{ xs: 12, sm: 12 }}>
                    {cardType !== 0 && (
                      <TableContainer
                        component={Paper}
                        sx={{ background: "var(--black)" }}
                      >
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell>#</TableCell>
                              <TableCell>Card Number</TableCell>
                              <TableCell>Card Type</TableCell>
                              <TableCell>Exp Date</TableCell>
                              <TableCell>Amount</TableCell>
                              <TableCell>Action</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {_.map(state.paymentData, (obj, index) => (
                              <TableRow key={index}>
                                <TableCell>{index + 1}</TableCell>
                                <TableCell>{obj.cardNumber}</TableCell>
                                <TableCell>{cardTypeLogo()}</TableCell>
                                <TableCell>{obj.expDate}</TableCell>
                                <TableCell>${state.ccAmount}</TableCell>
                                <TableCell>
                                  <IconButton
                                    color="primary"
                                    onClick={() => deleteGenerateToken(index)}
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    )}
                  </Grid>
                  { isAventiProducts || isAventiUpgrade ? (
                    <Typography
                      variant="h6"
                      fontWeight={800}
                      color="secondary.light"
                    >
                      {t("SignupCommonField.IBOSignup.PackageDetails")}{" "}
                      {state.packageName} ${state.packageTotalAmount}{" "}
                      <Typography
                        variant="h6"
                        fontWeight={400}
                        color="secondary.light"
                        component={"span"}
                      >
                        {t("SignupCommonField.IBOSignup.OneTime")}
                      </Typography>{" "}
                      {t("SignupCommonField.Common.then")} $
                      {state.reoccurringPackageAmount}{" "}
                      {t("SignupCommonField.Common.billedmonthly")}
                    </Typography>
                  ) : (
                    <Typography
                      variant="h6"
                      fontWeight={800}
                      color="secondary.light"
                    >
                      {t("SignupCommonField.IBOSignup.PackageDetails")}{" "}
                      {state.hardCodeName} ${state.packageTotalAmount}{" "}
                      <Typography
                        variant="h6"
                        fontWeight={400}
                        color="secondary.light"
                        component={"span"}
                      >
                        {t("SignupCommonField.IBOSignup.OneTime")}
                      </Typography>
                    </Typography>
                  )}

                  <Controller
                    name="terms"
                    control={control}
                    rules={{
                      required: t("SignupCommonField.Common.CheckboxRequired"),
                    }}
                    render={({ field, fieldState: { error } }) => (
                      <Stack direction={"column"} gap={0}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              {...field}
                              checked={!!field.value}
                              color="primary"
                            />
                          }
                          label={
                            <Typography variant="body2" color="secondary">
                              {t(
                                "SignupCommonField.IBOSignup.CheckboxTermConditionUpgrade"
                              )}{" "}
                              <Link
                                href={`${process.env.REACT_APP_BLOB_URL}/byldNetworkPolicy/IBOTermsAndConditions.pdf`}
                                underline="hover"
                                target="_blank"
                                rel="noopener noreferrer"
                                fontWeight={600}
                              >
                                {t(
                                  "SignupCommonField.IBOSignup.TermsAndConditions"
                                )}
                              </Link>
                            </Typography>
                          }
                        />
                        {error && (
                          <FormHelperText sx={{ mt: "5px" }} error>
                            {error.message}
                          </FormHelperText>
                        )}
                      </Stack>
                    )}
                  />
                  <ReCAPTCHA
                    maxWidth
                    sitekey={recaptchaSiteKey}
                    onChange={handleRecaptchaChange}
                  />
                  {recaptchaError && (
                    <Typography sx={{ fontSize: "12px" }} color="error">
                      {t("SignupCommonField.AffiliateSignUp.RecaptchaError")}
                    </Typography>
                  )}
                  <Stack gap={0.5} alignItems={"flex-start"}>
                    <Button
                      disabled={state.isSubmitDisabled}
                      type="submit"
                      variant="contained"
                      sx={{ px: 3 }}
                      color="primary"
                    >
                      {t("SignupCommonField.IBOSignup.SignUpButtonText")}
                    </Button>
                    { !isAventiProducts && (
                      <Typography variant="body2" color="secondary.light">
                        {t("SignupCommonField.Common.then")} $
                        {state.reoccurringPackageAmount}{" "}
                        {t("SignupCommonField.Common.billedmonthly")}
                      </Typography>
                    )}
                  </Stack>
                </Stack>
              </form>
              {/* Start Footer */}
              <>
                <Grid container spacing={3}>
                  <Stack direction={"row"} flexWrap={"wrap"} gap={2}>
                    <Typography
                      maxWidth={"420px"}
                      variant="body2"
                      color="secondary"
                    >
                      {t( isAventiProducts || isAventiUpgrade ? "SignupCommonField.IBOSignup.AventiFooterNote" : "SignupCommonField.IBOSignup.FooterNote1" )}
                    </Typography>
                    <img
                      src={`${process.env.REACT_APP_BLOB_URL}/backoffice-assets/PCI_Compilance1.png`}
                      className="cm-badges-signup"
                      alt="PCI Compilance"
                    />
                    <img
                      src={`${process.env.REACT_APP_BLOB_URL}/backoffice-assets/PCI_Compilance2.png`}
                      className="cm-badges-signup width-m170"
                      alt="PCI Compilance"
                    />
                  </Stack>
                </Grid>
                <Grid>
                  <Stack
                    direction={{ xs: "column", sm: "row" }}
                    flexWrap={"wrap"}
                    gap={2}
                    width={"100%"}
                    justifyContent={{ xs: "flex-start", sm: "flex-end" }}
                    mt={2}
                  >
                    <Typography variant="body2" color="secondary">
                      <Link
                        href={`${process.env.REACT_APP_BLOB_URL}/byldNetworkPolicy/PrivacyPolicy.pdf`}
                        underline="hover"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {t("SignupCommonField.IBOSignup.PrivacyPolicyLink")}
                      </Link>
                    </Typography>
                    <Typography variant="body2" color="secondary">
                      <Link
                        href={`${process.env.REACT_APP_BLOB_URL}/byldNetworkPolicy/TermsOfUse.pdf`}
                        underline="hover"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {t("SignupCommonField.IBOSignup.TermsOfUseLink")}
                      </Link>
                    </Typography>
                    <Typography variant="body2" color="secondary">
                      <Link
                        href={`${process.env.REACT_APP_BLOB_URL}/byldNetworkPolicy/MemberTermsAndConditions.pdf`}
                        underline="hover"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {t(
                          "SignupCommonField.IBOSignup.MemberTermsofConditionsLink"
                        )}
                      </Link>
                    </Typography>
                    <Typography variant="body2" color="secondary">
                      <Link href={"/login"} underline="hover" target="_blank">
                        {t("SignupCommonField.IBOSignup.AlreadyMemberLink")}
                      </Link>
                    </Typography>
                  </Stack>
                </Grid>
              </>
              {/* End Footer */}
            </Card>
          </Grid>
        </Grid>
      </Box>

      <CommonSnackBar snackObj={snack} closeSnack={closeSnack} buttonProp />

      <SignupRefPopup
        open={state.repModel}
        onClose={() => closeRepModelPopup()}
        onGetRefName={(e) => getREPId(e)}
      />
      <SignupCompletePopup
        open={state.signupModel}
        onClose={(goToAventi) => handleDashboard(goToAventi)}
        onCloseIcon={() => {
          if (location.state?.upgrade) {
            window.location.href = "/login";
          } else {
            navigate("/login");
          }
        }}
        acctID={acctID}
        isAventiAccountCreated={state.isAventiAccountCreated}
      />

      <Menu
        anchorEl={anchorElLanguage}
        open={Boolean(anchorElLanguage)}
        onClose={() => handleLanguageClose()}
      >
        {Object.entries(locales).map(([lang, { title }]) => (
          <MenuItem
            key={lang}
            selected={lang === currentLang}
            onClick={() => {
              handleLanguageClose(lang);
            }}
          >
            {title}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default IBOSignup;